import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

export type Theme = 'light' | 'dark';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly storageKey = 'cecile-theme';
  private currentTheme: Theme;

  constructor(@Inject(DOCUMENT) private readonly document: Document) {
    const saved = localStorage.getItem(this.storageKey) as Theme | null;
    this.currentTheme = saved ?? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
    this.apply(this.currentTheme);
  }

  get theme(): Theme {
    return this.currentTheme;
  }

  toggle(): Theme {
    this.currentTheme = this.currentTheme === 'dark' ? 'light' : 'dark';
    localStorage.setItem(this.storageKey, this.currentTheme);
    this.apply(this.currentTheme);
    return this.currentTheme;
  }

  private apply(theme: Theme): void {
    this.document.documentElement.dataset['theme'] = theme;
    this.document.documentElement.style.colorScheme = theme;
    this.document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')
      ?.setAttribute('content', theme === 'dark' ? '#181715' : '#f2efe8');
  }
}
